// Shared form-control styling so every <select>, <input>, and <textarea>
// across the app looks the same. Mirrors the inline code-builder dropdowns
// in ValuePicker — that style is the canonical one. Dark-mode variants
// follow the class-based `dark` variant applied on <html>.

import { cx } from "@/lib/cx";

const FOCUS = "focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500";

// Use for <select> elements. The chip style: blue accent, rounded, no native
// dropdown arrow. Width comes from the consumer.
export const selectClass = cx(
  "rounded border border-blue-300 bg-blue-50 px-2 py-1 text-sm text-blue-900",
  "dark:border-blue-700 dark:bg-blue-950 dark:text-blue-100",
  "appearance-none [appearance:none] [-webkit-appearance:none]",
  "hover:border-blue-500 dark:hover:border-blue-400",
  FOCUS,
);

// Compact variant for inline-string code chips (ValuePicker).
export const selectChipClass = cx(
  "rounded border border-blue-300 bg-blue-50 px-1 py-0.5 text-center font-mono text-base text-blue-900",
  "dark:border-blue-700 dark:bg-blue-950 dark:text-blue-100",
  "appearance-none [appearance:none] [-webkit-appearance:none]",
  "hover:border-blue-500 dark:hover:border-blue-400",
  FOCUS,
);

// Use for <input> and <textarea>.
export const inputClass = cx(
  "rounded border border-blue-300 bg-blue-50 px-2 py-1 text-sm text-blue-900 placeholder:text-blue-400",
  "dark:border-blue-700 dark:bg-blue-950 dark:text-blue-100 dark:placeholder:text-blue-500",
  "hover:border-blue-500 dark:hover:border-blue-400",
  FOCUS,
);

// Amber variant for free-text segments of a code that need to read as
// "you can type anything" (sizes like "9x9").
export const inputChipClass = cx(
  "rounded border border-amber-300 bg-amber-50 px-1 py-0.5 text-center font-mono text-base text-amber-900",
  "dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100",
  "hover:border-amber-500 dark:hover:border-amber-400",
  "focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500",
);
